import { createUUID } from "sb-helpers";
import { SportsMessageChannels } from "./sports";
import { BetslipMessageChannels } from "./betslip";
import { RealityCheckMessageChannels } from "./realityCheck";
import { PlayerMessageChannels } from "./player";
import { BetsReportingMessageChannels } from "./betsReporting";
import { CasinoMessageChannels } from "./casino";
import { CaptorMessageChannels } from "./captor";
import { SearchMessageChannels } from "./search";
import { ConnectionNames } from "../config";
export var SupportedMessageFormats;
(function (SupportedMessageFormats) {
    SupportedMessageFormats["jsonrpc2.0"] = "jsonrpc2.0";
})(SupportedMessageFormats || (SupportedMessageFormats = {}));
export const CasinoPlayerActivityAPIMessageChannels = {
    GetLastBetAge: "GetLastBetAge"
};
export const MessageChannels = {
    [ConnectionNames.sports]: SportsMessageChannels,
    [ConnectionNames.betslip]: BetslipMessageChannels,
    [ConnectionNames.realityCheck]: RealityCheckMessageChannels,
    [ConnectionNames.search]: SearchMessageChannels,
    [ConnectionNames.player]: PlayerMessageChannels,
    [ConnectionNames.betsReporting]: BetsReportingMessageChannels,
    [ConnectionNames.casino]: CasinoMessageChannels,
    [ConnectionNames.captor]: CaptorMessageChannels,
    [ConnectionNames.casinoPlayerActivity]: CasinoPlayerActivityAPIMessageChannels
};
export const MessageChannelsToIds = Object
    .keys(MessageChannels)
    .reduce((acc, name) => {
    acc[name] = Object
        .keys(MessageChannels[name])
        .reduce((a, b) => {
        a[b] = createUUID();
        return a;
    }, {});
    return acc;
}, {});
export const MessageChannelsIdToChannel = Object
    .keys(MessageChannelsToIds)
    .reduce((acc, name) => {
    Object
        .keys(MessageChannelsToIds[name])
        .forEach(a => {
        acc[MessageChannelsToIds[name][a]] = a;
    });
    return acc;
}, {});
//# sourceMappingURL=message.js.map